<script setup>
import { computed } from "vue";
import { Link, usePage } from "@inertiajs/vue3";

const props = defineProps({
  // Kunci halaman untuk mengambil konfigurasi dari backend (mis. "dosen").
  page: { type: String, default: "" },
  // Nilai fallback bila belum diatur di admin.
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
  current: { type: String, default: "" },
  image: { type: String, default: "" },
  color: { type: String, default: "#7a2f2f" },
});

const inertiaPage = usePage();

// Konfigurasi hero dari backend (dibagikan via HandleInertiaRequests).
const cfg = computed(() => {
  const all = inertiaPage.props?.pageHeroes || {};
  return (props.page && all[props.page]) || {};
});

const heroTitle = computed(() => cfg.value.title || props.title);
const heroSubtitle = computed(() =>
  cfg.value.subtitle != null && cfg.value.subtitle !== ""
    ? cfg.value.subtitle
    : props.subtitle
);
const heroCurrent = computed(() => props.current || heroTitle.value);
const heroColor = computed(() => cfg.value.color || props.color || "#7a2f2f");

const heroImage = computed(() => {
  const img = cfg.value.image || props.image;
  if (!img) return "/storage/images/BGUNG.png";
  if (/^https?:\/\//.test(img) || img.startsWith("/storage")) return img;
  return "/storage/" + img;
});

// Overlay gradient memakai warna terpilih (hex + alpha).
const overlayStyle = computed(() => ({
  backgroundImage: `linear-gradient(to right, ${heroColor.value}f2, ${heroColor.value}d9, ${heroColor.value}8c)`,
}));
</script>

<style scoped>
/* Full-bleed: tembus padding Container (px-4) hingga selebar viewport,
   dan tarik ke atas (-1rem) agar menempel tepat di bawah header. */
.hero-bleed {
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  margin-top: -1rem;
}
</style>

<template>
  <section class="relative overflow-hidden">
    <!-- Background image + overlay -->
    <div class="absolute inset-0">
      <img :src="heroImage" alt="" class="object-cover w-full h-full" />
      <div class="absolute inset-0" :style="overlayStyle"></div>
    </div>

    <div class="relative max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 py-16 sm:py-24">
      <!-- Breadcrumb -->
      <nav class="flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-white/70">
        <Link :href="route('home')" class="transition-colors hover:text-white">Beranda</Link>
        <span class="text-white/40">/</span>
        <span class="text-white">{{ heroCurrent }}</span>
      </nav>

      <!-- Judul akademik -->
      <h1 class="mt-4 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl font-playfair">
        {{ heroTitle }}
      </h1>

      <p v-if="heroSubtitle" class="max-w-2xl mt-4 text-sm leading-relaxed sm:text-base text-white/90">
        {{ heroSubtitle }}
      </p>
    </div>
  </section>
</template>
